import { NgModule } from '@angular/core';
import { CbEnumToLabelPipe } from './enum-to-label.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [CbEnumToLabelPipe],
    imports: [
        CommonModule
    ],
    exports: [
        CbEnumToLabelPipe
    ]
})
export class CbEnumToLabelModule { }
